var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultipleShippingPartners(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4492 42.1706L35.4491 42.1708C35.2518 42.8873 34.4602 43.4998 33.4235 43.4998H13.5765C12.5401 43.4998 11.7484 42.8873 11.5508 42.1706L11.5508 42.1704C11.5175 42.0501 11.5 41.9248 11.5 41.7956V26.204C11.5 25.3332 12.3534 24.5 13.5762 24.5H33.2209H33.2215C34.556 24.5 35.5 25.4108 35.5 26.3771V41.7956C35.5 41.9247 35.4825 42.0498 35.4492 42.1706Z",
    stroke: "#7939CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4536 24V31.0891C21.4536 31.3502 21.5971 31.485 21.6846 31.3064L23.405 27.7979C23.4577 27.6901 23.5398 27.6901 23.5925 27.7979L25.3131 31.3064C25.4006 31.485 25.5441 31.3499 25.5441 31.0891V24H21.4531H21.4536Z",
    fill: "#7939CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9442 37.4385H13.9357C13.5786 37.4385 13.2891 37.6862 13.2891 37.9917V40.1268C13.2891 40.4323 13.5786 40.68 13.9357 40.68H16.9442C17.3013 40.68 17.5908 40.4323 17.5908 40.1268V37.9917C17.5908 37.6862 17.3013 37.4385 16.9442 37.4385Z",
    fill: "#7939CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8062 38.1445H28.0281C27.909 38.1445 27.8125 38.2271 27.8125 38.329V38.4553C27.8125 38.5571 27.909 38.6397 28.0281 38.6397H33.8062C33.9253 38.6397 34.0218 38.5571 34.0218 38.4553V38.329C34.0218 38.2271 33.9253 38.1445 33.8062 38.1445Z",
    fill: "#7939CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0281 39.4785H33.8065C33.9254 39.4785 34.0221 39.5612 34.0221 39.663V39.7895C34.0221 39.8912 33.9254 39.9739 33.8065 39.9739H28.0281C27.9092 39.9739 27.8125 39.8912 27.8125 39.7895V39.663C27.8125 39.5612 27.9092 39.4785 28.0281 39.4785Z",
    fill: "#7939CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8584 21V18C22.8584 16.4087 22.5197 14.8826 21.9168 13.7574C21.314 12.6321 20.4963 12 19.6438 12H13.2146C12.362 12 11.5444 12.6321 10.9415 13.7574C10.3387 14.8826 10 16.4087 10 18V21",
    stroke: "#7939CC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10C18.2091 10 20 8.20914 20 6C20 3.79086 18.2091 2 16 2C13.7909 2 12 3.79086 12 6C12 8.20914 13.7909 10 16 10Z",
    stroke: "#7939CC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8584 21V18C38.8584 16.4087 38.5197 14.8826 37.9168 13.7574C37.314 12.6321 36.4963 12 35.6438 12H29.2146C28.362 12 27.5444 12.6321 26.9415 13.7574C26.3387 14.8826 26 16.4087 26 18V21",
    stroke: "#7939CC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32 10C34.2091 10 36 8.20914 36 6C36 3.79086 34.2091 2 32 2C29.7909 2 28 3.79086 28 6C28 8.20914 29.7909 10 32 10Z",
    stroke: "#7939CC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleShippingPartners);
export default __webpack_public_path__ + "static/media/MultipleShippingPartners.035b15675d4785f6845ee66f664cfbfd.svg";
export { ForwardRef as ReactComponent };